import { Product } from './Product.model';

enum ProductVersionType {
  Class1Version = 'Class1Version',
  Class2Version = 'Class2Version',
}

export type MDRegion = 'EU' | 'US' | 'AU' | 'ID' | 'PH' | 'VN' | 'AE';

// About module constants
const MdSymbol = 'MD_Symbol';
const UdiSymbol = 'UDI_Symbol';
const DateofManufactureSymbol = 'Date_of_Manufacture_Symbol';
const ManufactureDate = '2026-05-11';
const ManufacturerSymbol = 'Manufacturer_Symbol';
const ManufacturerName = 'Eyetelligence Pty Ltd';
const ManufacturerParentName = 'Optain Health';
const ManufacturerAddress = 'Level 8, 1341 Dandenong Road, Chadstone VIC 3148';
const ProductVersion = {
  [ProductVersionType.Class1Version]: '4.0.36',
  [ProductVersionType.Class2Version]: '1.0.6',
};
const UserManualSymbol = 'User_Manual_Symbol';
const EuRepName = 'MedEnvoy Global BV';
const EuRepAddress = 'Prinses Margrietplantsoen 33, Suite 123, 2595 AM,';
const EuRepEmail = 'Vigilance@medenvoyglobal.com';
const EuRepSymbol = 'EU_Rep_Symbol';
const ImporterSymbol = 'Importer_Symbol';
const ChRepName = 'Prolens AG';
const ChRepAddress = 'Josefstrasse 53,';
const ChRepLocation = '8005 Zürich, Switzerland';
const ChRepEmail = 'info@prolens.ch';
const ChRepSymbol = 'CH_REP_Symbol';

export type RegionSpecificDisplay = {
  UdiNumber?: string;
  MDName: { [key in Product]?: string };
  UdiQrCode?: string;
  EcRepInfoLine1?: string;
  EcRepInfoLine2?: string;
  EcRepInfoLine3?: string;
  EcRepInfoLine4?: string;
  EcRepInfoLine5?: string;
  EcRepSymbol?: string;
  Mdd?: string;
  CeMarkNotifiedBodyName?: string;
  CeMarkSymbol?: string;
  HasEuRep?: boolean;
  HasChRep?: boolean;
  RefSymbol?: string;
  SnSymbol?: string;
  ConsultManualBeforeUseSymbol?: string;
  ProductVersionType: ProductVersionType;
};

export const EU: RegionSpecificDisplay = {
  MDName: {
    [Product.ASSUREPLUS]: 'Assure Plus',
  },
  UdiNumber: '(01)00860011973201(8012)',
  UdiQrCode: 'EU_UDI_QR_code',
  EcRepInfoLine1: 'Compliance Management Solutions Europe LTD',
  EcRepInfoLine2: '2 Bulgaria Str.',
  EcRepInfoLine3: '2850 Petrich',
  EcRepInfoLine4: 'Bulgaria',
  EcRepInfoLine5: '',
  EcRepSymbol: 'EC_REP_Symbol',
  CeMarkNotifiedBodyName: 'DQS Medizinprodukte GmbH',
  CeMarkSymbol: 'CE_Mark_CE0297_Symbol',
  HasEuRep: true,
  HasChRep: true,
  RefSymbol: 'REF_Symbol',
  SnSymbol: 'SN_Symbol',
  ConsultManualBeforeUseSymbol: 'Consult_Manual_Before_Use_Symbol',
  ProductVersionType: ProductVersionType.Class2Version,
};

export const US: RegionSpecificDisplay = {
  MDName: {
    [Product.OPTAIN]: 'OPTDR01',
  },
  // UdiNumber: '(01)00860011973218(8012)',
  // UdiQrCode: 'US_UDI_QR_code',
  ProductVersionType: ProductVersionType.Class2Version,
};

export const AU: RegionSpecificDisplay = {
  MDName: {
    [Product.ASSUREPLUS_AU]: 'Assure Plus',
  },
  // UdiNumber: '(01)00860011973225(8012)',
  // UdiQrCode: 'AU_UDI_QR_code',
  ProductVersionType: ProductVersionType.Class1Version,
};

export const ID: RegionSpecificDisplay = {
  MDName: {
    [Product.ASSUREPLUS]: 'Assure Plus',
  },
  ProductVersionType: ProductVersionType.Class1Version,
};

export const PH: RegionSpecificDisplay = {
  MDName: {
    [Product.ASSUREPLUS]: 'Assure Plus',
  },
  ProductVersionType: ProductVersionType.Class1Version,
};

export const VN: RegionSpecificDisplay = {
  MDName: {
    [Product.ASSUREPLUS]: 'Assure Plus',
  },
  ProductVersionType: ProductVersionType.Class1Version,
};

export const AE: RegionSpecificDisplay = {
  MDName: {
    [Product.ASSUREPLUS]: 'Assure Plus',
  },
  ProductVersionType: ProductVersionType.Class1Version,
  Mdd: 'MDD',
};

export const About = {
  MdSymbol,
  UdiSymbol,
  DateofManufactureSymbol,
  ManufactureDate,
  ManufacturerSymbol,
  ManufacturerName,
  ManufacturerParentName,
  ManufacturerAddress,
  ProductVersion,
  UserManualSymbol,
  EuRepName,
  EuRepAddress,
  EuRepEmail,
  EuRepSymbol,
  ImporterSymbol,
  ChRepName,
  ChRepAddress,
  ChRepLocation,
  ChRepEmail,
  ChRepSymbol,
  EU,
  US,
  AU,
  ID,
  PH,
  VN,
  AE,
};
